import { render, staticRenderFns } from "./FormProspect.vue?vue&type=template&id=13080c43&scoped=true&"
import script from "./FormProspect.vue?vue&type=script&lang=js&"
export * from "./FormProspect.vue?vue&type=script&lang=js&"
import style0 from "./FormProspect.vue?vue&type=style&index=0&id=13080c43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13080c43",
  null
  
)

export default component.exports